import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import DeleteConfirmation from "../deleteConfirmation";
import Table from "../Theme/Table.js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Edit from "./Edit";
import Badge from "@mui/material/Badge";
import { Button } from "react-bootstrap";
import Add from "./Add";
import Spinner from "../Spinner";
import { useContext } from "react";
import { RoleContext } from "../RoleContext";
import TableSmall from "../Theme/TableSmall";
import TableSmalls from "../Theme/TableSmalls";
import ActionButtons from "../users/UsersActionButton.js";

import { 
  Edit as EditIcon, 
  Delete as DeleteIcon,
  Visibility as VisibilityIcon
} from '@mui/icons-material';
import Tooltip from '@mui/material/Tooltip';

const RolesList = () => {
  const roleData = useContext(RoleContext);
  const navigate = useNavigate();
  
  var role = JSON.parse(roleData);
  const [roles, setRoles] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [id, setId] = useState(null);
  const [data, setData] = useState(null);
  const getRoles = async () => {
    const response = await axios.get("roles/").then(notify());
    setRoles(response.data);
    setLoading(false);
    // setPermissions(response.data.role.permissions);
  };
  const showAddModal = () => {
    setDisplayAddModal(true);
  };

  const hideConfirmationModal = () => {
    setDisplayConfirmationModal(false);
  };

  const [deleteMessage, setDeleteMessage] = useState(null);
  const [displayAddModal, setDisplayAddModal] = useState(false);
  const [displayConfirmationModal, setDisplayConfirmationModal] =
    useState(false);
  const showDeleteModal = (id, name) => {
    setId(id);
    setDeleteMessage(`Are you sure you want to delete this role?`);
    setDisplayConfirmationModal(true);
  };

  const hideAddModal = () => {
    setDisplayAddModal(false);
  };
  const submitDelete = (id) => {
    console.log(id);
    deletePermission(id);
    setDisplayConfirmationModal(false);
    // getPassengers();
  };
  const deletePermission = async (id) => {
    const response = await axios.delete("/role/" + id, {
      data: { id: id },
    });
    getRoles();
  };

  const showEditModal = (id) => {
    setId(id);

    axios.get("/role/" + id, {}).then((res) => {
      setData(res.data.role);

      setDisplayEditModal(true);
    });
  };
  const [displayEditModal, setDisplayEditModal] = useState(false);

  // Hide add modal
  const hideEditModal = () => {
    setDisplayEditModal(false);
  };

  const edit = "role";
  const detail = "viewPassenger";
  const roleDetail = "viewRole";

  const notify = () =>
    toast.success("Roles list loaded.", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  useEffect(() => {
    getRoles();
  }, []);
  

  const columns = React.useMemo(
    () => [
      {
        Header: "Info",
        columns: [
          {
            Header: "Id",
            accessor: "id",
          },
          {
            Header: "Role Name",
            accessor: "role_name",
          },
          {
            Header: "Description",
            accessor: "role_description",
          },
          {
            Header: "Action",
            accessor: "action",
            disableFilters: true,
            Cell: (row) => (
              <div style={{ 
                display: "flex", 
                gap: "15px", 
                alignItems: 'center' 
              }}>
                {role.filter(e => e.perm_name === "edit_role").length > 0 && (
                  <Tooltip title="View Role Details">
                    <span>
                      <VisibilityIcon
                        color="success"
                        sx={{
                          cursor: 'pointer',
                          transition: 'transform 0.2s',
                          '&:hover': {
                            transform: 'scale(1.2)',
                            color: '#16a34a'
                          }
                        }}
                        onClick={() => navigate(`/${roleDetail}/${row.cell.row.original.id}`)}
                      />
                    </span>
                  </Tooltip>
                )}
                {role.filter(e => e.perm_name === "edit_role").length > 0 && (
                  <Tooltip title="Edit Role">
                    <span>
                      <EditIcon 
                        color="primary" 
                        sx={{ 
                          cursor: 'pointer',
                          transition: 'transform 0.2s',
                          '&:hover': {
                            transform: 'scale(1.2)',
                            color: '#1e40af'
                          }
                        }}
                        onClick={() => showEditModal(row.cell.row.original.id)}
                      />
                    </span>
                  </Tooltip>
                )}
                {role.filter(e => e.perm_name === "delete_role").length > 0 && (
                  <Tooltip title="Delete Role">
                    <span>
                      <DeleteIcon 
                        color="error" 
                        sx={{ 
                          cursor: 'pointer',
                          transition: 'transform 0.2s',
                          '&:hover': {
                            transform: 'scale(1.2)',
                            color: '#ff0000'
                          }
                        }}
                        onClick={() => showDeleteModal(row.cell.row.original.id)}
                      />
                    </span>
                  </Tooltip>
                )}
              </div>
            ),
          },
        ],
      },
    ],
    [role]
  );

  return (
    <div className="content-wrappers" style={{ marginTop: '-40px' }}>
    <div className="content-wrappers">
      <br />
      <br />
      <ToastContainer />

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
              <ActionButtons is_user={false} title="Roles" role={role} showAddModal={showAddModal} />

                {/* <div className="card-header">
                  <h3
                    className="card-title"
                    style={{ marginRight: 850 + "px" }}
                  >
                    List of Roles
                  </h3>

                  {role.filter(function (e) {
                    return e.perm_name === "add_role";
                  }).length > 0 && (
                    <Button
                      onClick={() => showAddModal()}
                      className="btn btn-success bt"
                    >
                      Add Role
                    </Button>
                  )}
                </div> */}

                <div className="card-body">
                  {/* <Table columns={columns} data={roles} edit={edit} /> */}
                  {loading ? (
                    <Spinner />
                  ) : (
                  <TableSmalls
                    columns={columns}
                    data={roles}
                    edit={edit}
                    detail={detail}
                  />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <DeleteConfirmation
        showModal={displayConfirmationModal}
        confirmModal={submitDelete}
        hideModal={hideConfirmationModal}
        id={id}
        message={deleteMessage}
      />
      {displayEditModal == true && (
        <Edit
          id={id}
          data={data}
          showModal={displayEditModal}
          hideModal={hideEditModal}
          getRoles={getRoles}
        />
      )}
      <Add showModal={displayAddModal} hideModal={hideAddModal} getRoles={getRoles}/>
    </div>
    </div>
  );
};
export default RolesList;
